
























import Vue from 'vue';
import Component from 'vue-class-component';
@Component
export default class App extends Vue {
  public dismissAlertCount = 5;
  public dismissCountdown = 0;

  public countDownChanged(dismissCountDown: number) {
    this.dismissCountdown = dismissCountDown;
  }

  public dismissAlert() {
    this.dismissCountdown = 0;
    this.$store.commit('dismissAlert');
  }
}
